import React, { useEffect, useState } from "react";
import { useLazyGetActivityHistoryByIdQuery } from "../../services/users";
import { useParams } from "react-router-dom";
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useLazyTutorActivityQuery } from "../../services/tutor";

const ActivityHistoryTutor = () => {
  const { _id } = useParams();
  const [rows, setRows] = useState<any>([]);

  const [getActivityHistoryById] = useLazyTutorActivityQuery();

  const fetchUserBooking = async () => {
    try {
      const result = await getActivityHistoryById({
        userId: _id,
        bookingType: "activity",
      }).unwrap();
      if ("data" in result && result.statusCode === 200) {
        const mappedBookings = result.data.booking.map((booking: any) => ({
          id: booking._id,
          bookingNumber: booking.bookingNumber,
          className: booking.subjectspecializations[0]?.name,
          bookingCost: booking.grandTotal,
          dateTimeSlot: new Date(booking.bookingdetails[0]?.date).toLocaleDateString(),
          activeStatus: mapBookingStatus(booking.bookingStatus),
        }));
        setRows(mappedBookings);
      } else {
        console.error("Failed to fetch user bookings:", result);
      }
    } catch (error) {
      console.error("Error fetching user bookings:", error);
    }
  };

  const mapBookingStatus = (bookingStatus: number) => {
    switch (bookingStatus) {
      case 1:
        return "PENDING";
      case 2:
        return "ACCEPTED";
      case 3:
        return "COMPLETED";
      case 4:
        return "REJECTED";
      case 5:
        return "CANCELLED";
      case 6:
        return "ONGOING";
      case 7:
        return "UPCOMING";
      default:
        return "UNKNOWN";
    }
  };

  useEffect(() => {
    if (_id) fetchUserBooking();
  }, [_id]);

  return (
    <Card sx={{ mt: 4 }} className="cards">
      <Box className="custom_tabs">
        <h2 className="mn_hdng">Activity History</h2>
      </Box>
      <TableContainer className="table_container">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">S.No</TableCell>
              <TableCell align="center">Booking id</TableCell>
              <TableCell align="center">Class Name</TableCell>
              <TableCell align="center">Booking cost</TableCell>
              <TableCell align="center">Date & Time slot</TableCell>
              <TableCell align="center">Active Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6}>
                  <Typography align="center">No activity history</Typography>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((booking: any, index: number) => (
                <TableRow key={booking.id}>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">{booking.bookingNumber}</TableCell>
                  <TableCell align="center">{booking.className}</TableCell>
                  <TableCell align="center">${booking.bookingCost}</TableCell>
                  <TableCell align="center">{booking.dateTimeSlot}</TableCell>
                  <TableCell align="center">{booking.activeStatus}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default ActivityHistoryTutor;
